import { ChangeEvent, FC } from 'react'
import { Input } from './styles'

interface MoneyInputProps {
  value: number
  onChange: (v: number) => void
  disabled?: boolean
  style?: React.CSSProperties
}

const fmtBRL = (n: number): string =>
  n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

/**
 * Campo monetário: exibe "R$ 1.234,56" e edita por dígitos (centavos).
 * Armazena o valor numérico em reais.
 */
export const MoneyInput: FC<MoneyInputProps> = ({ value, onChange, disabled, style }) => {
  const handle = (e: ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '')
    onChange(digits ? Number(digits) / 100 : 0)
  }
  return (
    <Input
      inputMode="numeric"
      disabled={disabled}
      value={value ? fmtBRL(value) : ''}
      onChange={handle}
      placeholder="R$ 0,00"
      style={style}
    />
  )
}

interface MoneyInputOpcionalProps {
  value: number | null
  onChange: (v: number | null) => void
  disabled?: boolean
  style?: React.CSSProperties
}

export const valorDigitado = (texto: string): number | null => {
  const digits = texto.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 12)
  return digits ? Number(digits) / 100 : null
}

export const MoneyInputOpcional: FC<MoneyInputOpcionalProps> = ({ value, onChange, disabled, style }) => (
  <Input
    inputMode="numeric"
    disabled={disabled}
    value={value == null ? '' : fmtBRL(value)}
    onChange={(e) => onChange(valorDigitado(e.target.value))}
    placeholder="R$ 0,00"
    style={style}
  />
)

export default MoneyInput
